import {NgModule} from '@angular/core';
import {FragmentIndexPipe} from './fragment-index.pipe';

@NgModule({declarations: [FragmentIndexPipe], exports: [FragmentIndexPipe]})
export class FragmentIndexModule {}
